import { ref, readonly } from 'vue'

const STORAGE_KEY = 'snowhub_theme'
const VALID_THEMES = ['light', 'dark']

const theme = ref(loadTheme())

function loadTheme() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    if (stored && VALID_THEMES.includes(stored)) return stored
  } catch {}
  return 'light'
}

function applyTheme() {
  document.documentElement.setAttribute('data-bs-theme', theme.value)
}

function setTheme(value) {
  if (!VALID_THEMES.includes(value)) return
  theme.value = value
  try { localStorage.setItem(STORAGE_KEY, value) } catch {}
  applyTheme()
}

function toggleTheme() {
  setTheme(theme.value === 'light' ? 'dark' : 'light')
}

export function useTheme() {
  return {
    theme: readonly(theme),
    setTheme,
    toggleTheme,
    initTheme: applyTheme
  }
}
